import React, { useEffect, useState } from "react";
import { Alert, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { api } from "../../../services/api";
import useEventoStore from "../../../stores/useEventoStore";
import EventoForm from "../../../components/evento/EventoForm";
import { fromEvento } from "../../../domain/evento/payload";
import { MODO_EDITAR } from "../../../domain/evento/schema";
import "./evento.css";

/* Paso "Información" del stepper cuando el evento ya existe (un borrador que
 * se retoma o al que se vuelve con "Atrás"): el mismo formulario, en modo
 * edición. Al guardar avisa al stepper para que siga al paso siguiente. */
const EditarInformacion = ({ eventId, onGuardado }) => {
  const [valoresIniciales, setValoresIniciales] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelado = false;

    useEventoStore.getState().fetchEvento(eventId)
      .then((data) => {
        if (cancelado) return;
        if (!data?.evento) {
          setError("No se pudo cargar el evento.");
          return;
        }
        setValoresIniciales(fromEvento(data.evento));
      })
      .catch((err) => {
        if (cancelado) return;
        console.error("Error al cargar el evento:", err);
        setError("No se pudo cargar el evento.");
      });

    return () => {
      cancelado = true;
    };
  }, [eventId]);

  const guardar = async (payload) => {
    try {
      const response = await api.eventos.setEvento(eventId, payload);

      if (response.status !== "success") {
        toast.error(response.message || "No se pudieron guardar los cambios.", {
          autoClose: 6000,
        });
        return;
      }

      toast.success("Los cambios se guardaron correctamente.");
      useEventoStore.getState().invalidar(eventId);
      onGuardado();
    } catch (err) {
      console.error("Error al guardar el evento:", err);
      toast.error("No se pudo conectar con el servidor.");
    }
  };

  if (error) {
    return <Alert severity="error" sx={{ m: 3 }}>{error}</Alert>;
  }

  if (!valoresIniciales) {
    return (
      <div className="d-flex justify-content-center p-5">
        <CircularProgress />
      </div>
    );
  }

  return (
    <EventoForm
      modo={MODO_EDITAR}
      valoresIniciales={valoresIniciales}
      onSubmit={guardar}
      textoSubmit="Guardar y continuar"
    />
  );
};

export default EditarInformacion;
